import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-namenbestand',
    templateUrl: './input-field.component.html'
} )
export class AdditionalNameComponent extends AbstractFieldComponent<string> {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.additionalName' );
    }

    set value( t: string | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.additionalName = t;
        }
    }

    get value(): string | undefined {
        return this.jobapplication?.additionalName;
    }
}
